export enum LicenseTypeEnum {
    ACADEMIC,
    COMMERCIAL,
    NO_LICENSE,
}

export interface License {
    license: LicenseTypeEnum,
    commercial: {
        rosetta: boolean,
        foldx: boolean,
    },
}
